module.exports = __webpack_public_path__ + "static/media/logo.659bb133.svg";